<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="closeCreatorsForList()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>


        <div class="relative w-[90%] h-[90%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>


            <div class="overflow-hidden h-full flex flex-col gap-y-2">


                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">
                    <div class="w-full flex flex-wrap items-center justify-between sm:flex-nowrap">

                        <div class="flex items-center">
                            <div
                                class="shrink-0 size-12 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                                    <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                                    <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                                    <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                                    <path d="M8 7v10" />
                                    <path d="M12 7v10" />
                                    <path d="M17 7v10" />
                                </svg>
                            </div>
                            <div class="ml-4">
                                <h3 class="text-sm font-semibold text-primary">Add Creators to Screening List</h3>
                                <p class="text-xs text-secondary">
                                    Below are the creators you have selected to add to a screening list. Assign them to
                                    a list to begin the screening process.
                                </p>
                            </div>
                        </div>

                        <div class="flex shrink-0">
                            <!-- <button type="button"
                            class="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-primary shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Button
                            text</button> -->
                        </div>
                    </div>
                </div>



                @if (confirmAddToScreening() && selectedScreeningList()) {
                <div class="flex-1 overflow-hidden flex flex-col items-center justify-center">
                    <div
                        class="shrink-0 z-10 w-full h-full rounded-2xl flex items-center justify-center primary-card-container">
                        @if (isProcessingInvites()) {
                        <atom-loading-inline title="Inviting Creators"
                            message="Sending invites to creators..."></atom-loading-inline>
                        } @else {
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="mx-auto size-12 text-gray-400">
                                <path
                                    d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                <path d="M12 17h.01" />
                            </svg>
                            <h3 class="mt-2 text-sm font-semibold text-primary">Add {{
                                socialScreeningService.selectedCreators().length }} Creator{{
                                socialScreeningService.selectedCreators().length > 1 ? 's' : '' }}
                            </h3>
                            <p class="mt-1 text-sm text-secondary">to</p>
                            <p class="mt-1 text-sm text-secondary">{{ selectedScreeningList()?.groupName }} group?</p>
                            <div class="mt-6 flex flex-row gap-x-2 items-center justify-center">
                                <button type="button" (click)="confirmAddToScreening.set(false)"
                                    class="secondary-button text-secondary">Cancel</button>
                                <button (click)="confirmAddToScreeningList()" type="button" class="primary-button">Add
                                    to Screening List</button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                } @else {
                <div class="flex-1 overflow-y-auto scrollbar-transparent flex flex-col gap-y-2">
                    <!-- Creator List -->
                    <div class="flex-1 z-10 w-full grid grid-cols-12 rounded-2xl gap-x-2 overflow-hidden">
                        <div
                            class="col-span-7 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 pt-1 pb-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <circle cx="9" cy="7" r="4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Selected Creators</h3>
                                        <p class="text-xs text-secondary">
                                            Below are the creators you have selected for screening.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2 text-transparent">
                                    @if (socialScreeningService.selectedCreators() &&
                                    socialScreeningService.selectedCreators().length > 0) {
                                    <p class="text-xs text-secondary truncate">{{
                                        socialScreeningService.selectedCreators().length }} Selected</p>
                                    }
                                </div>
                            </div>
                            <div class="py-2 flex flex-col gap-y-2 flex-1 overflow-hidden">
                                <div class="space-y-2 h-full overflow-y-auto scrollbar-hide">
                                    @if (socialScreeningService.selectedCreators() &&
                                    socialScreeningService.selectedCreators().length > 0) {
                                    <ul role="list" class="gap-y-1 flex flex-col">
                                        @for (creator of socialScreeningService.selectedCreators(); track $index) {
                                        <li class="flex items-center justify-between gap-x-6 card-container-pale">
                                            <div class="flex min-w-0 gap-x-4">

                                                <div class="size-10 flex-none rounded-full bg-gray-50 overflow-hidden">
                                                    <atom-ldg-img inputClass="object-cover" w="full" radius="full"
                                                        [src]="imageService.getImageSource(creator.photoURL, 'gallery_xl')"></atom-ldg-img>
                                                </div>
                                                <div class="min-w-0 flex-auto">
                                                    <p class="text-sm font-semibold text-primary">{{ creator.firstName
                                                        }} {{ creator.lastName.charAt(0) }}.
                                                    </p>
                                                    <div class="inline-flex gap-x-1.5 items-end">
                                                        <p class="text-xs text-secondary"> {{ creator.rating }} Star
                                                        </p>
                                                        <p class="truncate text-xs text-secondary">| {{
                                                            creator['total_reviews'] }} reviews</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-row gap-x-2 items-center">

                                                <!-- <span class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium bg-gray-200 dark:bg-gray-400/10 text-gray-400 inset-ring inset-ring-gray-400/20">Badge</span> -->

                                                <span
                                                    class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-400/10 text-secondary inset-ring inset-ring-gray-400/20">{{
                                                    formatService.convertIntToString(creator.tikTokFollowers +
                                                    creator.instaFollowers +
                                                    creator.snapchatFollowers + creator.youtubeSubscribers) }}
                                                    Followers</span>
                                                <span
                                                    class="inline-flex items-center rounded-m px-2 py-1 text-xs font-medium rounded-full bg-gray-100 dark:bg-gray-400/10 text-secondary inset-ring inset-ring-gray-400/20">{{
                                                    getAvgEngaegement(creator) | number:
                                                    '1.2-2' }}% Avg. Engagement</span>


                                                <button type="button"
                                                    (click)="removeSelectedCreator(creator)"
                                                    class="fab-button-secondary">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-4">
                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                                                        <path d="M3 6h18" />
                                                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                    }
                                    @else if (socialScreeningService.selectedCreators() &&
                                    socialScreeningService.selectedCreators().length == 0) {
                                    <div class="w-full h-full flex items-center justify-center">
                                        <div class="text-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="mx-auto size-12 text-gray-400">
                                                <circle cx="10" cy="7" r="4" />
                                                <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
                                                <circle cx="17" cy="17" r="3" />
                                                <path d="m21 21-1.9-1.9" />
                                            </svg>
                                            <h3 class="mt-2 text-sm font-semibold text-primary">No Creators Selected
                                            </h3>
                                            <p class="mt-1 text-sm text-secondary">Select creators to screen.
                                            </p>
                                            <div class="mt-6">
                                                <button (click)="closeCreatorsForList()" type="button"
                                                    class="inline-flex items-center rounded-md bg-primary px-3 py-1 text-xs font-semibold text-white shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                        aria-hidden="true" class="-ml-0.5 mr-1.5 size-4">
                                                        <path
                                                            d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                                                    </svg>
                                                    Select Creators
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    }
                                    @else {
                                    No creators selected.
                                    }
                                </div>
                            </div>
                        </div>

                        @if (socialScreeningService.screeningBriefId()) {
                        <div
                            class="col-span-5 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 py-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                            <path d="m9 15 2 2 4-4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Add to Screening List</h3>
                                        <p class="text-xs text-secondary">
                                            Adding creators to the screening list.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2 text-transparent">

                                </div>
                            </div>
                            <div class="px-2 py-2 flex flex-col gap-y-2 flex-1 overflow-hidden">
                                @if (specificScreeningList()) {
                                <div class="flex-1 space-y-2 h-full overflow-y-auto scrollbar-hide">

                                    <!-- Brief Overview -->
                                    <div
                                        class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg border bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-zinc-700">
                                        <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                            <div class="flex items-center flex-row gap-x-2">
                                                <div
                                                    class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path
                                                            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                                        <path d="m9 15 2 2 4-4" />
                                                    </svg>
                                                </div>
                                                <div class="">
                                                    <h3 class="text-sm font-semibold text-primary">Brief Overview
                                                    </h3>
                                                </div>
                                            </div>
                                            <div class="flex shrink-0 gap-x-2 text-transparent">
                                                RHS
                                            </div>
                                        </div>
                                        <div class="flex flex-col w-full py-3 px-3 gap-y-3">

                                            <div class="flex flex-col w-full">
                                                <h3 class="text-sm font-semibold text-primary">{{
                                                    specificScreeningList()?.groupName }}</h3>
                                            </div>

                                            <!-- <div class="w-full grid grid-cols-3 gap-2">
                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Status</p>
                                                    <p class="text-xs text-primary">Status
                                                    </p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Video Format</p>
                                                    <p class="text-xs text-primary">{{ getVideoFormat() }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Duration</p>
                                                    <p class="text-xs text-primary">{{ getVideoDuration() }}</p>
                                                </div>

                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Videos / Creator</p>
                                                    <p class="text-xs text-primary">{{
                                                        specificScreeningBrief()?.videosPerCreator }}</p>
                                                </div>

                                                @if (specificScreeningBrief()?.shoutBrief) {
                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Channel</p>
                                                    <p class="text-xs text-primary">{{ getSocialChannel() }}</p>
                                                </div>
                                                } @else {
                                                <div class="col-span-1">
                                                    <p class="text-xs font-light text-secondary">Channel</p>
                                                    <p class="text-xs text-primary">UGC Only</p>
                                                </div>
                                                }
                                            </div> -->
                                        </div>
                                    </div>
                                    <!-- Brief Overview END -->

                                    <!-- Product Overview -->
                                    <div
                                        class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden rounded-lg border bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-zinc-700">
                                        <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                            <div class="flex items-center flex-row gap-x-2">
                                                <div
                                                    class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="size-5">
                                                        <path
                                                            d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                                                        <path d="M12 22V12" />
                                                        <polyline points="3.29 7 12 12 20.71 7" />
                                                        <path d="m7.5 4.27 9 5.15" />
                                                    </svg>
                                                </div>
                                                <div class="">
                                                    <h3 class="text-sm font-semibold text-primary">Product</h3>
                                                </div>
                                            </div>
                                            <div class="flex shrink-0 gap-x-2 text-transparent">

                                            </div>
                                        </div>
                                        <div class="px-3 py-3">
                                            <!-- <div class="flex items-center flex-row gap-x-4">
                                                <div
                                                    class="relative flex-shrink-0 size-16 rounded-full outline outline-1 -outline-offset-1 outline-black/5">
                                                    <atom-ldg-img inputClass="object-cover" w="full" h="full"
                                                        radius="full"
                                                        [src]="imageService.getImageSource(specificScreeningBrief()?.product?.productImage, 'gallery')"></atom-ldg-img>
                                                </div>

                                                <div class="flex flex-col">
                                                    <h3 class="text-sm text-primary">{{
                                                        specificScreeningBrief()?.product?.productName }}</h3>
                                                    <p class="text-xs text-secondary line-clamp-2">{{
                                                        specificScreeningBrief()?.product?.productDescription
                                                        }}</p>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                    <!-- Product Overview END -->
                                </div>

                                } @else {
                                <div class="h-full w-full flex items-center justify-center">
                                    <atom-loading-inline title="Focussing Brief"
                                        message="Will be with you in a moment..." />
                                </div>
                                }
                            </div>
                        </div>
                        } @else {
                        <div
                            class="col-span-5 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden flex flex-col primary-card-container">
                            <div class="flex flex-row items-center justify-between flex-nowrap px-2 pt-1 pb-2">
                                <div class="flex items-center flex-row gap-x-2">
                                    <div
                                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path
                                                d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                            <path d="m9 15 2 2 4-4" />
                                        </svg>
                                    </div>
                                    <div class="flex flex-col">
                                        <h3 class="text-sm font-semibold text-primary">Select Screening List</h3>
                                        <p class="text-xs text-secondary">
                                            Add creators to a list, Screen that list against a Screening brief.
                                        </p>
                                    </div>
                                </div>
                                <div class="flex shrink-0 gap-x-2 text-transparent">

                                </div>
                            </div>
                            <div class="px-2 py-1 flex flex-col gap-y-2 flex-1 overflow-hidden">

                                <div class="flex-1 space-y-2 h-full overflow-y-auto scrollbar-hide">
                                    <div class="space-y-2 h-full overflow-y-auto scrollbar-hide">
                                        @if (displayScreeningLists() && displayScreeningLists()!.length > 0) {
                                        <ul role="list" class="gap-y-1 flex flex-col">
                                            @for (list of displayScreeningLists(); track list.id) {
                                            <li (click)="selectList(list)"
                                                class="flex items-center justify-between gap-x-6 card-container-pale cursor-pointer">

                                                <div class="min-w-0 flex-auto">
                                                    <p class="text-sm font-semibold text-primary">{{ list.groupName }}
                                                    </p>
                                                </div>

                                                @if (specificScreeningList() && specificScreeningList()?.id === list.id)
                                                {
                                                <svg class="size-6 text-green-500" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24" fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                                        clip-rule="evenodd" />
                                                </svg>

                                                } @else {
                                                <svg class="size-6 text-secondary" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512">
                                                    <circle cx="256" cy="256" r="192" fill="none" stroke="currentColor"
                                                        stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="32" />
                                                </svg>
                                                }
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                    <!-- Creator List END -->

                </div>
                }





                <div class="shrink-0 z-10 w-full flex flex-row gap-x-4 p-2 justify-between card-container-pale">

                    <!-- <button type="button" (click)="closeCreatorsForList()" class="rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-primary shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Close</button> -->
                    <div class="flex flex-row gap-x-2 items-center">
                        <button type="button" (click)="closeCreatorsForList()"
                            class="secondary-button text-secondary">Close</button>
                    </div>


                    <div class="flex flex-row gap-x-2 items-center">


                        <button type="button" (click)="clearSelection()" class="secondary-button text-secondary">Clear
                            Selection</button>

                        <button type="button" (click)="addToList()" class="primary-button">Add to
                            List</button>
                    </div>


                </div>


            </div>



            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>
        </div>
    </div>
</div>